class Video {
  constructor() {
    this.videoThumbnails = document.querySelectorAll('.lc-video__thumbnail-container');
    this.videos = document.querySelectorAll('.lc-video__consent-container');

    let googleConsent = this.checkGoogleConsent();

    if(this.videoThumbnails.length > 0) {

      if(googleConsent) {
        this.showVideo();
      } else {
        this.showConsent();
      }
    }
  }

  getCookie(e) {
    const t = `; ${document.cookie}`.split(`; ${e}=`);
    if (2 === t.length)
        return t.pop().split(";").shift()
  }

  checkGoogleConsent() {
    const e = this.getCookie("OptanonConsent")
      , t = Object.fromEntries(new URLSearchParams(e))
      , {groups: n} = t;
    return n && n.includes("C0007:1");
  }

  showConsent() {
    this.videoThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {

        let container = thumbnail.closest('.lc-video');

        container.classList.add('lc-video__consent--active');

        this.videos.forEach(video => {
          let button = video.querySelector('.lc-video__consent-button');

          button.addEventListener('click', () => {

            this.addYoutube(video);

            container.classList.remove('lc-video__consent--active');

            if (thumbnail) {
              thumbnail.classList.add('fade-out');
              thumbnail.style.display = 'none';
            }

          });
        });
      });
    });
  }

  showVideo() {
    this.videoThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {

        this.addYoutube(thumbnail.closest('.lc-video'));

        setTimeout(() => {
          if (thumbnail) {
            thumbnail.classList.add('fade-out');
            thumbnail.style.display = 'none';
          }
        }, 200);
      });
    });
  }


  addYoutube(video) {
    let trigger = video.querySelector('.lc-video__consent-trigger');

    let dataSource = trigger.getAttribute('data-source');
    let source = "https://www.youtube-nocookie.com/embed/{SOURCE}?rel=0&controls=0&showinfo=0&autoplay=1&mute=1";

    source = source.replace( "{SOURCE}", dataSource );

    video.querySelector('.lc-video__consent-iframe').setAttribute( "src", source );

    OneTrust.setConsentProfile({"purposes": [{"Id" : "FFD2BB61-AE3F-4EEF-BBBD-F84EE6091248", "TransactionType": "CONFIRMED"}]});
    document.getElementsByClassName ('save-preference-btn-handler onetrust-close-btn-handler')[0]. click() ;
  }
}


export default Video;
